import {
  CommonTextInputField,
  type CommonTextInputFieldProps,
} from "../../../../common-ui/form-fields/CommonTextInputField";
import { getFieldProps } from "../../../../common-ui/form-fields/getFieldProps";
import { useMaskInput } from "../../../../common/hooks/useMaskInput";
import type { CreateIntermodalFormModelStringKeys } from "../../../../services/intermodal/createIntermodalReducer";
import { useCreateIntermodalField } from "../../hooks/useCreateIntermodalField";

interface CreateIntermodalTextInputFieldProps<
  Key extends CreateIntermodalFormModelStringKeys,
> extends Omit<CommonTextInputFieldProps, "onValueChange" | "trackerAction"> {
  maskInput?: (value: string) => string;
  name: Key;
}

export function CreateIntermodalTextInputField<
  Key extends CreateIntermodalFormModelStringKeys,
>({ name, maskInput, ...props }: CreateIntermodalTextInputFieldProps<Key>) {
  const { onChange: onFieldChange, ...fieldProps } =
    useCreateIntermodalField(name);
  const onChange = useMaskInput(onFieldChange, maskInput);

  return (
    <CommonTextInputField
      {...props}
      {...getFieldProps(props, { ...fieldProps, onChange })}
    />
  );
}
